import cloneDeep from "lodash/cloneDeep";
import { ProductModel, VariantTraitModel } from "@insite/client-framework/Types/ApiModels";

export default function useFilterUnusedVaraintTraits(variantTraits: VariantTraitModel[], variantChildren: ProductModel[]) {
    const traits = cloneDeep(variantTraits.slice());
    const childValuesList = variantChildren.map(o => o.childTraitValues!);

    traits.forEach(variantTrait => {
        const filteredValuesIds: string[] = [];
        childValuesList.forEach(childTraitList => {
            const currentValue = childTraitList.find(traitValue => traitValue.styleTraitId === variantTrait.id);
            if (!currentValue) {
                return;
            }
            if (!filteredValuesIds.some(filteredValueId => filteredValueId === currentValue.id)) {
                filteredValuesIds.push(currentValue.id);
            }
        })
        variantTrait.traitValues = variantTrait.traitValues!.filter(traitValue => filteredValuesIds.indexOf(traitValue.id) > -1).sort((a, b) => a.sortOrder - b.sortOrder);
    })

    return traits.sort((a, b) => a.sortOrder - b.sortOrder);
}